/* Carte à gratter Nomaï — extrait de sections/nomai-grattage.liquid (N4-1). */
(function(){
function init(){
  var d = document.getElementById('NomaiGrattage');
  if (!d || d.dataset.init) return;
  d.dataset.init = '1';
  var onglet = d.nextElementSibling;
  var CLE = 'nomaiGrattage';
  var jours = parseInt(d.dataset.jours, 10) || 14;
  var delai = (parseInt(d.dataset.delai, 10) || 25) * 1000;
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  var apercu = d.dataset.apercu === '1';
  var $ = function(s){ return d.querySelector(s); };
  function lire(){ try { return JSON.parse(localStorage.getItem(CLE)) || {}; } catch(e){ return {}; } }
  function ecrire(o){ try { localStorage.setItem(CLE, JSON.stringify(o)); } catch(e){} }
  function euros(n){ return n + ' €'; }
  // Mesure anonyme de l'entonnoir dans GA4 (gtag du thème, même consentement que les pages vues). Aucune donnée personnelle.
  function mesure(nom, extra){
    if (apercu || typeof window.gtag !== 'function') return;
    var p = {habillage: d.dataset.habillage, appareil: mobile ? 'mobile' : 'ordinateur'};
    for (var k in extra) p[k] = extra[k];
    try { window.gtag('event', nom, p); } catch(e){}
  }
  var LIB = { ev: d.dataset.libEv || 'Cocooning Days', bf: d.dataset.libBf || 'Black Friday', std: d.dataset.libStd || 'Nomaï' };

  // Grille « gain:seuil:chance » séparée par des virgules, réglable dans l'éditeur.
  var grille = (d.dataset.grille || '').split(',').map(function(t){
    var p = t.split(':'); return {gain: +p[0], seuil: +p[1], chance: +p[2]};
  }).filter(function(g){ return g.gain > 0 && g.chance > 0 && g.seuil >= 0; });
  // Grille vide ou mal saisie : pas de carte ni d'onglet, et un signal dans la console pour l'éditeur.
  if (!grille.length) {
    if (window.console) console.warn('Carte à gratter : grille de gains vide ou invalide, carte retirée.');
    if (onglet && onglet.classList.contains('ngr__onglet')) onglet.remove();
    d.remove();
    return;
  }
  $('.ngr__table').innerHTML = grille.map(function(g){
    return '<tr><td>' + euros(g.gain) + ' dès ' + euros(g.seuil) + " d'achat</td><td>" + g.chance + ' %</td></tr>';
  }).join('');

  var etat = lire();
  if (etat.fini && !apercu) return;
  if (!etat.gain || !grille.some(function(g){ return g.gain === etat.gain; })) {
    var total = grille.reduce(function(s, g){ return s + g.chance; }, 0), r = Math.random() * total, choix = grille[0];
    for (var i = 0; i < grille.length; i++) { if ((r -= grille[i].chance) < 0) { choix = grille[i]; break; } }
    etat.gain = choix.gain; ecrire(etat);
  }
  var lot = grille.filter(function(g){ return g.gain === etat.gain; })[0];

  $('.ngr__montant').textContent = euros(lot.gain);
  $('.ngr__seuil').textContent = 'dès ' + euros(lot.seuil) + " d'achat";
  $('.ngr__invite').textContent = 'Où envoyer votre code de ' + euros(lot.gain) + ' ?';
  $('.ngr__bouton').textContent = 'Garder mes ' + euros(lot.gain);

  // ---- Grattage ----
  var carte = $('.ngr__carte'), toile = $('.ngr__toile'), ctx = null, peinte = false, revele = false, enCours = false, prec = null, dernier = 0;
  // Surfaces à gratter : bouclette (par défaut), tricot (Cocooning Days), velours côtelé (Black Friday).
  function bouclette(l, h){
    var g = ctx.createLinearGradient(0, 0, l, h); g.addColorStop(0, '#efe6d6'); g.addColorStop(1, '#e6dac6');
    ctx.fillStyle = g; ctx.fillRect(0, 0, l, h);
    for (var i = 0, n = Math.round(l * h / 14); i < n; i++) {
      var x = Math.random() * l, y = Math.random() * h, rr = 2.2 + Math.random() * 3.2, a = Math.random() * 6.283, b = a + Math.PI * (1.2 + Math.random() * .7);
      ctx.lineWidth = 1.1 + Math.random() * .9;
      ctx.strokeStyle = 'rgba(120,98,68,.22)'; ctx.beginPath(); ctx.arc(x + .8, y + 1, rr, a, b); ctx.stroke();
      ctx.strokeStyle = Math.random() < .5 ? 'rgba(255,252,245,.9)' : 'rgba(246,239,227,.95)'; ctx.beginPath(); ctx.arc(x, y, rr, a, b); ctx.stroke();
    }
    ctx.fillStyle = 'rgba(240,232,218,.18)'; ctx.fillRect(0, 0, l, h);
  }
  function jambe(x1, y1, x2, y2, w){
    ctx.lineWidth = w + 1.6; ctx.strokeStyle = 'rgba(122,96,66,.26)'; ctx.beginPath(); ctx.moveTo(x1 + .8, y1 + 1.2); ctx.lineTo(x2 + .8, y2 + 1.2); ctx.stroke();
    ctx.lineWidth = w; ctx.strokeStyle = 'rgba(248,242,231,.96)'; ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
    ctx.lineWidth = w * .3; ctx.strokeStyle = 'rgba(210,193,168,.75)'; ctx.beginPath(); ctx.moveTo(x1 + w * .2, y1 + 1.5); ctx.lineTo(x2 + w * .1, y2 - 1.5); ctx.stroke();
  }
  function tricot(l, h){
    var g = ctx.createLinearGradient(0, 0, l, h); g.addColorStop(0, '#eee4d3'); g.addColorStop(1, '#e2d4be');
    ctx.fillStyle = g; ctx.fillRect(0, 0, l, h);
    var pas = Math.max(14, Math.round(l / 24)), rang = pas * .72, w = pas * .36;
    ctx.lineCap = 'round';
    for (var y = -rang; y < h + rang; y += rang) {
      for (var x = -pas / 2; x < l + pas; x += pas) {
        var j = (Math.random() - .5) * 1.4, bas = y + rang * 1.25;
        jambe(x + pas * .1 + j, y, x + pas * .5, bas, w);
        jambe(x + pas * .9 + j, y, x + pas * .5, bas, w);
      }
    }
    ctx.fillStyle = 'rgba(240,232,218,.1)'; ctx.fillRect(0, 0, l, h);
  }
  function arrondi(x, y, w, h, r){
    ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }
  function etiquette(l, h, police){
    // Étiquette tissée cousue sur la maille.
    var lw = Math.min(l * .58, 240), lh = Math.max(42, h * .25), x = (l - lw) / 2, y = (h - lh) / 2 - 8, t = Math.round(lh * .38);
    ctx.fillStyle = 'rgba(92,68,53,.2)'; arrondi(x + 1.5, y + 2.5, lw, lh, 4); ctx.fill();
    ctx.fillStyle = '#f6f1e9'; arrondi(x, y, lw, lh, 4); ctx.fill();
    ctx.setLineDash([4, 3]); ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(138,75,51,.6)'; arrondi(x + 5, y + 5, lw - 10, lh - 10, 2); ctx.stroke(); ctx.setLineDash([]);
    ctx.fillStyle = '#3b2a21'; ctx.font = 'italic ' + t + 'px ' + police;
    while (t > 10 && ctx.measureText(LIB.ev).width > lw - 26) { t--; ctx.font = 'italic ' + t + 'px ' + police; }
    ctx.fillText(LIB.ev, l / 2, y + lh / 2 + 1);
  }
  function velours(l, h, police){
    ctx.fillStyle = '#261a14'; ctx.fillRect(0, 0, l, h);
    var c = Math.max(7, Math.round(l / 46));
    for (var x = 0; x < l; x += c) {
      var g = ctx.createLinearGradient(x, 0, x + c, 0);
      g.addColorStop(0, '#211610'); g.addColorStop(.5, '#4a3529'); g.addColorStop(1, '#211610');
      ctx.fillStyle = g; ctx.fillRect(x, 0, c, h);
    }
    var s = ctx.createLinearGradient(0, 0, l, h);
    s.addColorStop(0, 'rgba(255,236,210,0)'); s.addColorStop(.42, 'rgba(255,236,210,.11)'); s.addColorStop(.6, 'rgba(255,236,210,0)');
    ctx.fillStyle = s; ctx.fillRect(0, 0, l, h);
    for (var i = 0, n = Math.round(l * h / 40); i < n; i++) {
      ctx.fillStyle = Math.random() < .5 ? 'rgba(0,0,0,.2)' : 'rgba(255,240,220,.05)';
      ctx.fillRect(Math.random() * l, Math.random() * h, 1, 1 + Math.random() * 2);
    }
    ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(201,168,119,.5)'; ctx.strokeRect(10.5, 10.5, l - 21, h - 21);
    ctx.fillStyle = '#c9a877'; ctx.font = 'italic ' + Math.round(Math.min(l, h) * .15) + 'px ' + police;
    ctx.fillText(LIB.bf, l / 2, h / 2 - 8);
  }
  function peindre(){
    ctx = toile.getContext('2d', {willReadFrequently: true});
    var ratio = Math.min(window.devicePixelRatio || 1, 2), l = carte.clientWidth, h = carte.clientHeight;
    toile.width = Math.round(l * ratio); toile.height = Math.round(h * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    var hab = d.dataset.habillage, police = getComputedStyle($('.ngr__titre')).fontFamily;
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    if (hab === 'cocooning') { tricot(l, h); etiquette(l, h, police); }
    else if (hab === 'black-friday') { velours(l, h, police); }
    else {
      bouclette(l, h);
      ctx.fillStyle = 'rgba(107,100,92,.55)';
      ctx.font = 'italic ' + Math.round(Math.min(l, h) * .16) + 'px ' + police;
      ctx.fillText(LIB.std, l / 2, h / 2 - 8);
    }
    peinte = true;
    $('.ngr__etat').textContent = '0 % découvert';
  }
  function pos(e){ var b = toile.getBoundingClientRect(); return {x: e.clientX - b.left, y: e.clientY - b.top}; }
  function gratter(a, b){
    ctx.globalCompositeOperation = 'destination-out'; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.lineWidth = Math.max(30, carte.clientWidth * .1);
    ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x + .01, b.y); ctx.stroke();
  }
  function mesurer(){
    var l = toile.width, h = toile.height, px = ctx.getImageData(0, 0, l, h).data, vides = 0, pts = 0;
    for (var y = 0; y < h; y += 12) for (var x = 0; x < l; x += 12) { pts++; if (px[(y * l + x) * 4 + 3] < 40) vides++; }
    return vides / pts;
  }
  function suivre(forcer){
    if (revele) return;
    var t = performance.now(); if (!forcer && t - dernier < 120) return; dernier = t;
    var part = mesurer();
    $('.ngr__etat').textContent = Math.round(part * 100) + ' % découvert';
    if (part >= .5) reveler('gratte');
  }
  function reveler(mode){
    if (revele) return; revele = true;
    if (!lire().revele) mesure('carte_grattee', {gain: lot.gain, mode: mode === 'gratte' ? 'gratte' : 'bouton'});
    toile.classList.add('is-parti'); carte.classList.add('is-gratte');
    $('.ngr__gain').setAttribute('aria-hidden', 'false');
    $('.ngr__etat').textContent = 'Vous gagnez ' + euros(lot.gain) + ' dès ' + euros(lot.seuil) + " d'achat";
    $('.ngr__reveler').hidden = true;
    $('.ngr__form').hidden = false;
    var e = lire(); e.revele = Date.now(); ecrire(e);
    if (!mobile) setTimeout(function(){ $('#NomaiGrattageEmail').focus({preventScroll: true}); }, 350);
  }
  toile.addEventListener('pointerdown', function(e){ if (revele) return; enCours = true; toile.setPointerCapture(e.pointerId); carte.classList.add('is-gratte'); prec = pos(e); gratter(prec, prec); });
  toile.addEventListener('pointermove', function(e){ if (!enCours || revele) return; var p = pos(e); gratter(prec, p); prec = p; suivre(false); });
  function lever(){ if (enCours) { enCours = false; suivre(true); } }
  toile.addEventListener('pointerup', lever); toile.addEventListener('pointercancel', lever);
  $('.ngr__reveler').addEventListener('click', reveler);

  // ---- Envoi à Klaviyo ----
  var compte = encodeURIComponent(d.dataset.compte);
  function appeler(chemin, corps){
    return fetch('https://a.klaviyo.com/client/' + chemin + '?company_id=' + compte, {
      method: 'POST', headers: {'Content-Type': 'application/vnd.api+json', 'revision': '2025-01-15'}, body: JSON.stringify(corps)
    }).then(function(r){ if (!r.ok) throw new Error(r.status); });
  }
  function participation(email, avecLettre){
    return appeler('events', {data: {type: 'event', attributes: {
      properties: {'Gain': lot.gain, 'Seuil': lot.seuil, 'Lettre': avecLettre, 'Source': d.dataset.source},
      metric: {data: {type: 'metric', attributes: {name: 'Participation tirage Nomaï'}}},
      profile: {data: {type: 'profile', attributes: {email: email}}}
    }}});
  }
  function inscription(email){
    return appeler('subscriptions', {data: {type: 'subscription', attributes: {
      custom_source: d.dataset.source,
      profile: {data: {type: 'profile', attributes: {email: email, properties: {'Gain carte à gratter': lot.gain, 'Seuil carte à gratter': lot.seuil}}}}
    }, relationships: {list: {data: {type: 'list', id: d.dataset.liste}}}}});
  }
  // Relie ce navigateur au profil inscrit : sans identification, Klaviyo ne voit ni visites ni fiches vues.
  function identifier(email){
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({email: email});
      else (window._klOnsite = window._klOnsite || []).push(['identify', {email: email}]);
    } catch (e) {}
  }
  var form = $('.ngr__form'), err = $('.ngr__erreur');
  function adresse(){
    var v = form.email.value.trim(); err.hidden = true;
    if (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return v;
    err.textContent = 'Cette adresse e-mail semble incomplète.'; err.hidden = false; form.email.focus(); return null;
  }
  function envoyer(avecLettre){
    var email = adresse(); if (!email) return;
    var boutons = d.querySelectorAll('.ngr__form button'); boutons.forEach(function(b){ b.disabled = true; });
    var envois = [participation(email, avecLettre)];
    if (avecLettre) envois.push(inscription(email));
    Promise.all(envois).then(function(){
      var e = lire(); e.fini = Date.now(); e.lettre = avecLettre; ecrire(e);
      if (avecLettre) identifier(email);
      form.hidden = true; $('.ngr__chances').hidden = true; $('.ngr__non').hidden = true;
      $('.ngr__merci-titre').textContent = avecLettre
        ? 'C’est noté : votre code de ' + euros(lot.gain) + ' arrive dans votre boîte mail d’ici quelques minutes. Pensez à regarder dans les courriers indésirables.'
        : 'C’est noté : vous participez au prochain tirage. Votre code de ' + euros(lot.gain) + ' reste à vous : écrivez à ' + d.dataset.contact + ' depuis cette adresse, nous vous l’envoyons.';
      $('.ngr__merci-code').hidden = !avecLettre;
      $('.ngr__merci').hidden = false;
      mesure(avecLettre ? 'carte_email_envoye' : 'carte_tirage_seul', {gain: lot.gain});
    }).catch(function(){
      err.textContent = "L'envoi n'a pas abouti. Réessayez dans un instant."; err.hidden = false;
      mesure('carte_envoi_echec', {gain: lot.gain});
    }).then(function(){ boutons.forEach(function(b){ b.disabled = false; }); });
  }
  form.addEventListener('submit', function(ev){ ev.preventDefault(); envoyer(true); });
  $('.ngr__tirage-seul').addEventListener('click', function(){ envoyer(false); });

  // ---- Ouverture, fermeture, déclencheurs ----
  var dejaOuverte = false;
  function ouvrir(source){
    if (d.open) return;
    if (document.querySelector('cart-drawer.active, .menu-drawer[open], details[open].menu-drawer-container')) return;
    dejaOuverte = true;
    mesure('carte_ouverte', {declencheur: typeof source === 'string' ? source : 'onglet'});
    onglet.hidden = true;
    if (mobile) d.show(); else d.showModal();
    if (lire().revele) { if (!peinte) { peindre(); } reveler(); }
    else if (!peinte) requestAnimationFrame(peindre);
  }
  function fermer(){ if (d.open) d.close(); }
  d.addEventListener('close', function(){
    var e = lire();
    if (!e.fini) { e.ferme = Date.now(); ecrire(e); onglet.hidden = false; mesure('carte_fermee', {etape: revele ? 'apres_grattage' : 'avant_grattage'}); }
  });
  $('.ngr__fermer').addEventListener('click', fermer);
  $('.ngr__non').addEventListener('click', fermer);
  $('.ngr__merci .ngr__bouton').addEventListener('click', fermer);
  d.addEventListener('click', function(ev){ if (ev.target === d) fermer(); });
  onglet.addEventListener('click', ouvrir);

  if (apercu) { ouvrir(); return; }
  // Geste 10 (27/10) : l'onglet est toujours disponible ; il ne s'efface que carte ouverte ou accroche mobile affichée.
  onglet.hidden = false;
  if (etat.ferme && Date.now() - etat.ferme < jours * 864e5) return;
  var vues = 1;
  try { vues = (parseInt(sessionStorage.getItem(CLE + 'Vues'), 10) || 0) + 1; sessionStorage.setItem(CLE + 'Vues', vues); } catch(e){}
  // Le bandeau cookies de Shopify recouvrirait la carte (surtout sur mobile) : on attend qu'il soit fermé.
  function bandeau(){ var b = document.getElementById('shopify-pc__banner'); return !!(b && b.getClientRects().length && getComputedStyle(b).visibility !== 'hidden'); }
  // Fiche produit (07/10) : ni ouverture automatique ni bandeau, sur mobile comme sur ordinateur.
  // Le visiteur y décide en quelques secondes sur la photo, le titre et le prix : seul l'onglet reste.
  if (/\/products\//.test(location.pathname)) return;
  // Geste 10 (27/10) : page d'arrivée d'une visite payante (marqueur publicitaire dans l'adresse) :
  // ni ouverture automatique ni accroche, l'onglet seul. La 2e page de la visite suit la règle commune.
  if (pagePub()) return;
  if (mobile && vues < 2) { accroche(); return; }
  var parti = false, attente = false;
  function declencher(){
    if (parti || attente || dejaOuverte) return;
    if (bandeau()) { attente = true; setTimeout(function(){ attente = false; declencher(); }, 3000); return; }
    parti = true;window.removeEventListener('scroll', auScroll); document.removeEventListener('mouseout', sortie); ouvrir('auto'); }
  function auScroll(){ var h = document.documentElement.scrollHeight - innerHeight; if (h > 0 && scrollY / h > (mobile ? .4 : .5)) declencher(); }
  function sortie(ev){ if (!ev.relatedTarget && ev.clientY <= 0) declencher(); }
  // Geste 10 (27/10), ordinateur, 1re page vue de la visite : ouverture seulement après un engagement réel,
  // 45 s de page au premier plan ET la moitié de la page parcourue. Ni délai seul ni intention de sortie.
  if (vues < 2) { engagement(45, .5); return; }
  setTimeout(declencher, mobile ? Math.min(delai, 12000) : delai);
  window.addEventListener('scroll', auScroll, {passive: true});
  if (!mobile) document.addEventListener('mouseout', sortie);

  function pagePub(){
    try {
      var q = new URLSearchParams(location.search);
      if (['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid'].some(function(k){ return q.has(k); })) return true;
      return ['cpc', 'paid', 'ppc'].indexOf((q.get('utm_medium') || '').trim().toLowerCase()) > -1;
    } catch(e){ return false; }
  }
  function engagement(secondes, part){
    var actives = 0, lu = false;
    function parcours(){ var h = document.documentElement.scrollHeight - innerHeight; if (h <= 0 || scrollY / h >= part) { lu = true; window.removeEventListener('scroll', parcours); } }
    var horloge = setInterval(function(){
      if (dejaOuverte) { clearInterval(horloge); return; }
      if (!document.hidden) actives++;
      if (actives >= secondes && lu) { clearInterval(horloge); declencher(); }
    }, 1000);
    window.addEventListener('scroll', parcours, {passive: true});
    parcours();
  }

  // Mobile, 1re page vue : pas de fenêtre plein écran (règle de Google sur les interstitiels intrusifs).
  // L'onglet tout de suite, puis un bandeau bas compact après 3 s ou 25 % de défilement, qui grandit
  // 4 s plus tard en mini-carte (aperçu de la surface à gratter, environ 15 % de l'écran) ;
  // la carte ne s'ouvre que sur un geste du visiteur.
  function accroche(){
    onglet.hidden = false;
    var vu = false, attend = false;
    function montrer(){
      if (vu || attend || d.open) return;
      if (bandeau()) { attend = true; setTimeout(function(){ attend = false; montrer(); }, 3000); return; }
      vu = true; window.removeEventListener('scroll', defil);
      if (document.getElementById('NomaiGrattageAccroche')) return;
      var gains = grille.map(function(g){ return g.gain; }),
          min = Math.min.apply(null, gains), max = Math.max.apply(null, gains),
          b = document.createElement('div');
      b.id = 'NomaiGrattageAccroche';
      b.className = 'ngr__accroche ngr__accroche--' + d.dataset.habillage;
      b.innerHTML = '<button type="button" class="ngr__accroche-ouvrir">'
        + '<span class="ngr__accroche-apercu" aria-hidden="true"><span class="ngr__accroche-lib"></span><span>Grattez du doigt</span></span>'
        + '<span class="ngr__accroche-ligne"><span><strong>Carte à gratter</strong> · '
        + (min === max ? euros(min) : min + ' à ' + euros(max)) + ' de remise</span>'
        + '<span class="ngr__accroche-cta">Gratter</span></span></button>'
        + '<button type="button" class="ngr__accroche-fermer" aria-label="Fermer">×</button>';
      var hab = d.dataset.habillage;
      b.querySelector('.ngr__accroche-lib').textContent = hab === 'cocooning' ? LIB.ev : hab === 'black-friday' ? LIB.bf : LIB.std;
      b.querySelector('.ngr__accroche-ouvrir').addEventListener('click', function(){ b.remove(); ouvrir('bandeau'); });
      b.querySelector('.ngr__accroche-fermer').addEventListener('click', function(){
        var e = lire(); e.ferme = Date.now(); ecrire(e); b.remove(); onglet.hidden = false;
        mesure('carte_bandeau_ferme', {etape: b.classList.contains('is-grand') ? 'mini' : 'bandeau'});
      });
      onglet.hidden = true;
      document.body.appendChild(b);
      // Ne jamais couvrir la barre d'achat collée des fiches produit (#nomai-sticky-atc) : on se pose au-dessus.
      var barre = document.getElementById('nomai-sticky-atc'), cadre = 0, fin;
      function caler(){
        cadre = 0; if (!b.isConnected) return;
        var h = 0;
        if (barre) { var r = barre.getBoundingClientRect(), cs = getComputedStyle(barre);
          if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height && r.top < innerHeight - 4) h = Math.max(0, innerHeight - r.top); }
        b.style.bottom = h ? 'calc(' + Math.round(h + 8) + 'px + env(safe-area-inset-bottom))' : '';
      }
      // + un recalage 350 ms après le dernier défilement : la barre apparaît/disparaît avec une transition.
      function planifier(){ if (!cadre) cadre = requestAnimationFrame(caler); clearTimeout(fin); fin = setTimeout(caler, 350); }
      caler();
      if (barre) { window.addEventListener('scroll', planifier, {passive: true}); window.addEventListener('resize', planifier);
        setTimeout(caler, 400); setTimeout(caler, 4400); }
      mesure('carte_bandeau_vu');
      // Sur une fiche produit, le bandeau reste compact : la mini-carte cacherait le titre et le prix.
      if (!/\/products\//.test(location.pathname)) setTimeout(function(){ if (b.isConnected && !d.open) { b.classList.add('is-grand'); mesure('carte_mini_vue'); } }, 4000);
    }
    function defil(){ var h = document.documentElement.scrollHeight - innerHeight; if (h > 0 && scrollY / h > .25) montrer(); }
    setTimeout(montrer, 3000);
    window.addEventListener('scroll', defil, {passive: true});
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', init);
})();
